/**
 * Created by mac on 2020/1/16.
 */
// 设置 rem 函数
function setRem () {

    //1440 默认大小24px; 1920px = 60rem ;每个元素px基础上/16
    let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    let htmlDom = document.getElementsByTagName('html')[0];
    //设置根元素字体大小
    //得到html的Dom元素
    htmlDom.style.fontSize= htmlWidth/60 + 'px';
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
    setRem()
}
